import React from 'react';
import Login from '../components/Login'; 
// Re-use Login component but you can customize this later
export default function Register() {
  return <Login isRegister={true} />;
}
